import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useProcesses } from '../../context/ProcessesContext';
import ProcessTrainingProgressDisplay from './ProcessTrainingProgressDisplay';
import './ProcessTrainingWindow.css';

interface ProcessTrainingWindowProps {
  processId: string;
  onClose: () => void;
}

const ProcessTrainingWindow: React.FC<ProcessTrainingWindowProps> = ({ processId, onClose }) => {
  const { getProcess } = useProcesses();
  const [isMinimized, setIsMinimized] = useState(false);
  
  const process = getProcess(processId);

  if (!process) {
    return null;
  }

  const handleMinimize = () => {
    setIsMinimized(true);
  };

  const handleRestore = () => {
    setIsMinimized(false);
  };

  if (isMinimized) {
    return (
      <div className="process-window-minimized" onClick={handleRestore}>
        <div className="minimized-indicator">
          <span>{process.name}</span>
          <span className="minimized-status">{process.status}</span>
        </div>
      </div>
    );
  }

  return (
    <AnimatePresence>
      <motion.div
        className="process-training-window-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <motion.div
          className="process-training-window"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="process-window-header">
            <h2 className="process-window-title">{process.name}</h2>
            <div className="process-window-controls">
              <button
                className="process-window-btn process-window-btn-minimize"
                onClick={handleMinimize}
                title="Minimize"
              >
                −
              </button>
              <button
                className="process-window-btn process-window-btn-close"
                onClick={onClose}
                title="Close"
              >
                ×
              </button>
            </div>
          </div>
          <div className="process-window-content">
            <ProcessTrainingProgressDisplay processId={processId} />
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ProcessTrainingWindow;

